import React from "react";
import { getIcons } from "../../Constant/Constant";

const InfoModel = ({ show, close, title, message, leadCount, dealCount,reassignHandle ,dealReassignHandle,userDeactiveHandle}) => {
  if (!show) return null;

  const icon = getIcons();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 w-[554px] h-[322px]  rounded-xl shadow-xl  ">
        <div className="flex flex-col items-center  px-7">
          <img src={icon?.confirmationWarning} className="w-16 h-16" />
          <div className="flex items-center flex-col gap-8 mt-6">
            <div className="text-lg font-semibold text-gray-900">{title}</div>
            <div className="text-sm  text-gray-900">{message}</div>
          </div>
        </div>

        <div className="flex justify-center gap-6 items-center mt-12">
          {dealCount > 0 ? (
           <>
           <button
                onClick={close}
                className="bg-[#AFAFAF] w-[134px] h-[42px] text-white font-semibold"
              >
                cancel
              </button>
              <button
                onClick={dealReassignHandle}
                className="bg-customGreen w-[134px] h-[42px] text-white font-semibold"
              >
                Reassign Deal
              </button>
           </>
          ) : leadCount > 0 ? (
            <>
              <button
                onClick={close}
                className="bg-[#AFAFAF] w-[134px] h-[42px] text-white font-semibold"
              >
                cancel
              </button>
              <button
                onClick={reassignHandle}
                className="bg-customGreen w-[134px] h-[42px] text-white font-semibold"
              >
                Reassign
              </button>
            </>
          ) : (
            <>
            <button
                onClick={close}
                className="bg-[#AFAFAF] w-[134px] h-[42px] text-white font-semibold"
              >
                cancel
              </button>
              <button
                onClick={userDeactiveHandle}
                className="bg-customGreen w-[134px] h-[42px] text-white font-semibold"
              >
                Okay
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoModel;
